import requestConfig from 'app/requests/Prebooking.requests'
import {
    useDataGridSource,
} from 'app/PoC/DataGridDemoPages/components/hooks'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import SkyNetDataGrid from 'app/PoC/DataGridDemoPages/components/SkyNetDataGrid'
import useStyles
    from 'app/PoC/DataGridDemoPages/ServiceCentersDemo/ServiceCentersDemoScenarioEditor/ServiceCentersDemoScenarioEditor.styles'
import useLabel from 'app/hooks/useLabel'

import columns from './PreBookings.columns'

const PreBookings = ({
    serviceCenterId,
}: Readonly<{ serviceCenterId: number }>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const dataSource = useDataGridSource({
        request: {
            ...requestConfig.getPreBookingsByServiceCenter(),
            data: {
                filters: {
                    serviceCenterId: String(serviceCenterId),
                },
                sortField: 'requestedHandover',
                sortType: 'desc',
            },
        },
        key: RequestKeys.getPreBookings,
    })

    return (
        <SkyNetDataGrid
            persistentKey="demo-serviceCenterPreBookings-table"
            columns={columns}
            customDataSource={dataSource}
            toolbarProps={{
                title: l('PRE_BOOKINGS'),
                showClearSort: false,
                showQuickFilter: true,
            }}
            classNames={{
                container: classes.tableContainer,
                tableWrapper: classes.tableWrapper,
            }}
        />
    )
}

export default PreBookings
